import React, { useEffect, useRef, useState, useContext, useCallback } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Hidden,
    IconButton,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { initialCamPos } from "../utils/commonUtils.js/commonFunc";
import stateContext from "../Context/StateContext";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import CloseIcon from "@mui/icons-material/Close";
import "../App.css";
import FontStyle from "./TabsContent/FontStyle";
import MetalStyle from "./TabsContent/MetalStyle";
import Thickness from "./TabsContent/Thickness";
import ChainStyle from "./TabsContent/ChainStyle";
import StoneStyle from "./TabsContent/StoneStyle";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { v4 as uuidv4 } from "uuid";
import AWS from "aws-sdk";
import SelectedFontInfo from "./Common/SelectedFontInfo";
import AddDiamond from "./TabsContent/AddDotDiamond";
import { LoadMetalData } from "./TabsContent/LoadMetalData";
import { DescriptionDetails } from "./Description";

export default function MainSidebar() {
    // Check for onlyOne parameter in URL
    const searchParams = new URLSearchParams(window.location.search);
    const onlyOne = searchParams.get("onlyOne");

    const [expandedAccordion, setExpandedAccordion] = useState(null);
    const [value, setValue] = useState(0);
    const [activeFontIndex, setActiveFontIndex] = useState(0);
    const [inputText, setInputText] = useState("Haref");
    const [inputTextInSearchBar, setInputTextInSearchBar] = useState("");

    const [activeIndex, setActiveIndex] = useState(2);
    const [activeThickness, setActiveThickness] = useState(1.02);
    const [activeStone, setActiveStone] = useState(null);

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const textRef = useRef(null);
    const globalState = useContext(stateContext);
    const isAccordionView = useMediaQuery("(max-width:1024px)");
    const accordionRefs = {
        fontStyle: useRef(null),
        metalStyle: useRef(null),
        thickness: useRef(null),
        stoneStyle: useRef(null),
        chainStyle: useRef(null),
        addDiamond: useRef(null),
    };

    const totalTabs = 7;

    const handleNext = () => {
        globalState.setActiveTabIndex((prevValue) =>
            prevValue === totalTabs - 1 ? 0 : prevValue + 1
        );
        setValue((prevValue) =>
            prevValue === totalTabs - 1 ? 0 : prevValue + 1
        );
    };

    const handlePrev = () => {
        globalState.setActiveTabIndex((prevValue) =>
            prevValue === 0 ? totalTabs - 1 : prevValue - 1
        );
        setValue((prevValue) =>
            prevValue === 0 ? totalTabs - 1 : prevValue - 1
        );
    };

    useEffect(() => {
        let totalPrice = Object.values(globalState.prices).reduce(
            (acc, curr) => acc + curr,
            0
        );
        totalPrice += globalState.chainCharmPrice;
        totalPrice += globalState.dotDiamondPrice;
        const profitMargin = parseFloat(globalState.profit);
        let totalCartPrice = parseFloat(totalPrice.toFixed(2));
        totalCartPrice = parseFloat(((totalCartPrice + profitMargin) * 1.15).toFixed(2));
        globalState.setFinalPrice(totalCartPrice);
    }, [
        globalState.prices,
        globalState.chainCharmPrice,
        globalState.dotDiamondPrice,
    ]);

    useEffect(() => {
        if (globalState.selectedFontLanguage === "English") {
            setInputTextInSearchBar("Haref");

            const getNameFromParams = searchParams.get("name");
            const getTypeFromParams = searchParams.get("type");

            if (getNameFromParams) {
                let fontNo = parseInt(getTypeFromParams.split("")[4]);
                setInputTextInSearchBar(getNameFromParams);
                setActiveFontIndex(fontNo - 1);
                globalState.setFontNo(getTypeFromParams);
                setInputText(getNameFromParams);
                globalState.setText(getNameFromParams);
            } else {
                setActiveFontIndex(0);
                globalState.setSelectedFont(
                    globalState.firstFontBuffers.english
                );
                globalState.setSelectedFontData(
                    globalState.fonts.find(
                        (font) => font.language === "English"
                    )
                );
                if (globalState.fonts.length) {
                    globalState.setPriceDeviation(
                        globalState.fonts.find(
                            (font) => font.language === "English"
                        ).deviation
                    );
                }
                globalState.setFontNo("font1");
                setInputText("Haref");
                globalState.setText("Haref");
            }
        } else {
            setActiveFontIndex(0);
            setInputTextInSearchBar("نوف");
            globalState.setSelectedFont(globalState.firstFontBuffers.arabic);
            if (globalState.fonts.length) {
                globalState.setPriceDeviation(
                    globalState.fonts.find((font) => font.language === "Arabic")
                        .deviation
                );

                globalState.setDeviationData({
                    smallDeviation: globalState.fonts.find(
                        (font) => font.language === "Arabic"
                    ).smallDeviation,
                    mediumDeviation: globalState.fonts.find(
                        (font) => font.language === "Arabic"
                    ).deviation,
                    largeDeviation: globalState.fonts.find(
                        (font) => font.language === "Arabic"
                    ).largeDeviation,
                });
            }
            globalState.setFontNo("arabicFont1");
            setInputText("نوف");
            globalState.setText("نوف");
        }
    }, [globalState.selectedFontLanguage]);

    const handleInputChange = (event) => {
        const inputText = event.target.value;
        const isArabic = globalState.selectedFontLanguage === "Arabic";
        let hasEnglish;
        if (isArabic) {
            hasEnglish = /[A-Za-z]/.test(inputText);
            if (hasEnglish) {
                globalState.setMessage(
                    "Cannot use English letters in Arabic mode"
                );
                return; // Exit early if English letter is detected
            }
        }

        if (inputText.includes(" ")) {
            globalState.setMessage("Cannot use special characters or space");
            return; // Exit early if space is detected
        }

        const filteredText = inputText
            .replace(/[^A-Za-z\u0600-\u06FF\u0900-\u097F]/g, "")
            .replace(/\s/g, "");
        setInputTextInSearchBar("");

        if (
            globalState.selectedFontLanguage === "English" &&
            filteredText === ""
        ) {
            setInputText("Haref");
            globalState.setText("Haref");
        } else if (
            globalState.selectedFontLanguage === "Arabic" &&
            filteredText === ""
        ) {
            setInputText("نوف");
            globalState.setText("نوف");
        } else {
            let formattedText;

            if (globalState.selectedFontLanguage === "English") {
                formattedText = filteredText.replace(/[^A-Za-z]/g, ""); // Allow only English letters
                formattedText =
                    formattedText.charAt(0).toUpperCase() +
                    formattedText.slice(1);
            } else if (globalState.selectedFontLanguage === "Arabic") {
                formattedText = filteredText.replace(
                    /[^؀-\u06FF\uFB50-\uFDFF\uFE70-\uFEFF]/g,
                    ""
                ); // Allow only Arabic characters
            }

            setInputText(formattedText);
            if (inputText.length > formattedText.length) {
                // Backspace is pressed, so set inputTextInSearchBar to an empty string
                setInputTextInSearchBar("");
            } else {
                setInputTextInSearchBar(formattedText);
            }
            globalState.setText(formattedText);
        }
    };

    const TabPanel = ({ children, value, index, className }) => {
        return (
            <div className={className} role="tabpanel" hidden={value !== index}>
                {value === index && <>{children}</>}
            </div>
        );
    };

    useEffect(() => {
        let elementList = document.querySelectorAll(
            ".tabpanel__content-box-text"
        );

        elementList.forEach((element) => {
            while (element.offsetWidth < element.scrollWidth) {
                element.style.fontSize = `${
                    parseFloat(
                        window
                            .getComputedStyle(element)
                            .fontSize.replace("px", "")
                    ) - 2
                }px`;
            }
        });
    });

    const handleChangeAccordion = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : false);

        if (isExpanded && accordionRefs[panel]?.current) {
          setTimeout(() => {
            accordionRefs[panel].current.scrollIntoView({
                behavior: "smooth",
                block: "start", // aligns the top of the element with the top of the scroll area
            });
        }, 200); 
        }
        if (isExpanded) {
            switch (panel) {
                case "fontStyle":
                    globalState.setActiveTabIndex(0);
                    setValue(0);
                    break;
                case "metalStyle":
                    globalState.setActiveTabIndex(1);
                    setValue(1);
                    break;
                case "thickness":
                    globalState.setActiveTabIndex(2);
                    setValue(2);
                    break;
                case "stoneStyle":
                    globalState.setActiveTabIndex(3);
                    setValue(3);
                    break;
                case "chainStyle":
                    globalState.setActiveTabIndex(4);
                    setValue(4);
                    break;
                case "diamondStyle":
                    globalState.setActiveTabIndex(5);
                    setValue(5);
                    break;
                case "addDiamond":
                    globalState.setActiveTabIndex(5);
                    setValue(5);
                    break;
                case "description":
                    globalState.setActiveTabIndex(6);
                    setValue(6);
                    break;
                default:
                    globalState.setActiveTabIndex(0);
                    setValue(0);
            }
        }
    };

    const handleChangeTabs = (event, newValue) => {
        globalState.setActiveTabIndex(newValue);
        setValue(newValue);
    };
    const [selectedButtonType, setSelectedButtonType] = useState(0);

    const takeScreenShotOfCanvas = async () => {
        await initialCamPos(globalState);
        const canvas = document
            .getElementById("canvas3D")
            .getElementsByTagName("canvas")[0];
        let dataUrl = canvas.toDataURL("image/png");

        const s3 = new AWS.S3({
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_KEY,
            region: process.env.REACT_APP_REGION,
        });

        const base64Image = dataUrl.replace(/^data:image\/\w+;base64,/, "");
        const buffer = Buffer.from(base64Image, "base64");
        const uniqueId = uuidv4();

        const params = {
            Bucket: "haref-images",
            Key: `images/${uniqueId}.jpg`,
            Body: buffer,
            ContentType: "image/jpeg",
            ACL: "public-read",
        };
        let svg = globalState.svgData;
        const svgParams = {
            Bucket: "haref-images",
            Key: `svgs/${uniqueId}.svg`,
            Body: svg,
            ContentType: "image/svg+xml",
            ACL: "public-read",
        };
        try {
            const [imageResult, svgResult] = await Promise.all([
                new Promise((resolve, reject) => {
                    s3.upload(params, (err, data) => {
                        if (err) {
                            console.error("Error uploading image:", err);
                            reject(err);
                        } else {
                            resolve(data.Location);
                        }
                    });
                }),
                new Promise((resolve, reject) => {
                    s3.upload(svgParams, (err, data) => {
                        if (err) {
                            console.error("Error uploading SVG:", err);
                            reject(err);
                        } else {
                            resolve(data.Location);
                        }
                    });
                }),
            ]);
            return { imageLocation: imageResult, svgLocation: svgResult };
        } catch (error) {
            console.error("Error uploading image:", error);
            return null;
        }
    };

    const triggerCheckout = (value, { imageLocation, svgLocation }) => {
        const createProduct = async (text, price) => {
            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_UPLOAD_API_ENDPOINT}`,
                    {
                        text: text,
                        price: price.toString(),
                    }
                );

                if (res.status === 200) {
                    let variantId = res.data.product.variants[0].id;
                    let textWeight = globalState.textWeight.toFixed(2);
                    let totalWeight =
                        globalState.textWeight + globalState.chainWeight;
                    totalWeight = totalWeight.toFixed(2);
                    const productData = {
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                properties: {
                                    text: globalState.text,
                                    font: globalState.selectedFontLanguage,
                                    _fontStyle:
                                        globalState.selectedFontData.name,
                                    metal: globalState.selectedMetalData.name,
                                    thickness: globalState.fontThickness,
                                    styleColor: globalState.fontStyleColor,
                                    _noOfDotDiamond: globalState.noOfDotDiamond,
                                    charmType: globalState.selectedCharm,
                                    charmColor: globalState.charmColorName,
                                    chainStyle:
                                        globalState.selectedChainData.label,
                                    _textWeight: textWeight,
                                    totalWeight: totalWeight,
                                    _buttonType: value,
                                    _screenshot: imageLocation,
                                    _svgImage: svgLocation,
                                },
                            },
                        ],
                    };
                    setLoading(false);
                    setLoading2(false);
                    window.parent.postMessage(productData, "*");
                } else {
                }
            } catch (err) {
                console.log(err);
                setErrorMessage(err.body.message);
                setTimeout(() => {
                    setErrorMessage("");
                }, 5000);
                setLoading(false);
                setLoading2(false);
            }
        };

        const {
            text,
            selectedFontLanguage,
            fontNo,
            selectedMetalData,
            fontThickness,
            selectedChainData,
            textWeight,
            finalPrice,
        } = globalState;

        if (
            text &&
            selectedFontLanguage &&
            fontNo &&
            selectedMetalData &&
            fontThickness &&
            value !== 0 &&
            selectedChainData &&
            textWeight !== 0 &&
            finalPrice !== 0 &&
            imageLocation !== ""
        ) {
            createProduct(globalState.text, Math.round(globalState.finalPrice));
        }
    };

    const handleAddToCart = (value) => {
        let scene = globalState.scene;
        if (scene && scene.getObjectByName("dimensions")) {
            scene.getObjectByName("dimensions").visible = false;
        }
        if (value === 1) {
            setSelectedButtonType(1);
            setLoading2(true);
        } else {
            setSelectedButtonType(2);
            setLoading(true);
        }
        takeScreenShotOfCanvas()
            .then((dataUrl) => {
                triggerCheckout(value, dataUrl);
                if (scene && scene.getObjectByName("dimensions")) {
                    scene.getObjectByName("dimensions").visible = true;
                }
            })
            .catch((error) => {
                console.error("Error taking screenshot:", error);
            });
    };

    const isArabic = globalState.selectedFontLanguage === "Arabic";
    const tabConfig = [
        // { key: "description", en: "Description", ar: "الوصف" },
        { key: "fontStyle", en: "Font Style", ar: "الخط" },
        { key: "metal", en: "Metal", ar: "المعدن" },
        { key: "thickness", en: "Thickness", ar: "السماكة" },
        { key: "charmStone", en: "Charm & Stone", ar: "التعاليق والأحجار" },
        { key: "chainStyle", en: "Chain Style", ar: "السلسلة" },
        { key: "addDiamond", en: "Diamond Attachment", ar: "إضافة فصوص" },
    ];
    const activeTabs = tabConfig.map((tab) => ({
        key: tab.key,
        label: isArabic ? tab.ar : tab.en,
    }));

    // Define button labels
    const buttonLabels = {
        en: {
            previous: "Previous",
            next: "Next",
            buyNow: "Buy Now",
            addToCart: "Add to cart",
        },
        ar: {
            previous: "السابق",
            next: "التالي",
            buyNow: "اشتري الآن",
            addToCart: "أضف إلى السلة",
        },
    };

    // Pick labels based on selected language
    const currentButtonLabels =
        globalState.selectedFontLanguage === "Arabic"
            ? buttonLabels.ar
            : buttonLabels.en;

    return (
        <div
            className="main__sidebar"
            style={onlyOne === "true" ? { marginTop: 0, marginBottom: 0 } : {}}
        >
            <div className="main__sidebar-search">
                <input
                    id="inputText"
                    type="text"
                    value={inputTextInSearchBar}
                    onChange={handleInputChange}
                    placeholder="Enter name or text here"
                    ref={textRef}
                    maxLength="10"
                />
            </div>

           {!isAccordionView ? (
                <>
                    <Tabs
                        value={value}
                        onChange={handleChangeTabs}
                        className="tabConatiner"
                    >
                        {activeTabs.map((tab) => (
                            <Tab
                                key={tab.key}
                                label={tab.label}
                                className="tabpanel__tab"
                            />
                        ))}
                    </Tabs>
                    <div className="main__sidebar-tabpanel">
                        <TabPanel
                            value={value}
                            index={0}
                            className="tabpanel__content"
                        >
                            <FontStyle
                                activeFontIndex={activeFontIndex}
                                setActiveFontIndex={setActiveFontIndex}
                                inputText={inputText}
                            />
                        </TabPanel>
                        <TabPanel
                            value={value}
                            index={1}
                            className="tabpanel__content"
                        >
                            <MetalStyle
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        </TabPanel>
                        <TabPanel
                            value={value}
                            index={2}
                            className="tabpanel__content"
                        >
                            <Thickness
                                activeThickness={activeThickness}
                                setActiveThickness={setActiveThickness}
                            />
                        </TabPanel>
                        <TabPanel
                            value={value}
                            index={3}
                            className="tabpanel__content"
                        >
                            <StoneStyle
                                activeStone={activeStone}
                                setActiveStone={setActiveStone}
                            />
                        </TabPanel>
                        <TabPanel
                            value={value}
                            index={4}
                            className="tabpanel__content"
                        >
                            <ChainStyle />
                        </TabPanel>
                        <TabPanel
                            value={value}
                            index={5}
                            className="tabpanel__content"
                        >
                            <AddDiamond />
                        </TabPanel>
                        
                    </div>
                </>
           ) : (
                <>
                    <div className="mobile-description-content">
                        <FontAccordion
                            isArabic={isArabic}
                            description={
                                <div
                                    className="description-content-section-main"
                                    style={{
                                        textAlign: isArabic ? "right" : "center",
                                        direction: isArabic ? "rtl" : "ltr",
                                        fontSize: 14,
                                        fontWeight: isArabic ? 600 : 400,
                                        color: "#000",
                                        whiteSpace: "pre-wrap",
                                    }}
                                >
                                    <p style={{ margin: "0 0 10px 0" }}>
                                        {globalState.description}
                                    </p>
                                    <p style={{ margin: 0, fontSize: "13px" }}>
                                        الدوران والابتعاد تجربة قد تريد او لبعض بشكل نسقط
                                    </p>
                                </div>
                            }
                            details={
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: "12px 24px",
                                    }}
                                >
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic ? "الخط" : "Font"}
                                        </div>
                                        {globalState.selectedFontData && (
                                            <div
                                                style={{
                                                    color: "#fff",
                                                    fontSize: 14,
                                                }}
                                            >
                                                {globalState.selectedFontData?.arabicName ??
                                                    globalState.selectedFontData?.name}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic ? "المعدن/العيار" : "Metal/Carat"}
                                        </div>
                                        <div
                                            style={{
                                                color: "#fff",
                                                fontSize: 14,
                                            }}
                                        >
                                            {globalState.selectedMetalData?.arabicName ??
                                                globalState.selectedMetalData?.name}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic ? "السمك" : "Thickness"}
                                        </div>
                                        <div
                                            style={{
                                                color: "#fff",
                                                fontSize: 14,
                                                direction: "rtl",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    direction: "ltr",
                                                    unicodeBidi: "isolate",
                                                }}
                                            >
                                                {globalState.fontThickness} mm
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic ? "السلسلة" : "Chain"}
                                        </div>
                                        <div
                                            style={{
                                                color: "#fff",
                                                fontSize: 14,
                                            }}
                                        >
                                            نوع السلسلة: 40 مم السلاسل كلها
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic ? "الوزن التقريبي" : "Approx. weight"}
                                        </div>
                                        <div
                                            style={{
                                                color: "#fff",
                                                fontSize: 14,
                                            }}
                                        >
                                            {isArabic
                                                ? `${globalState.pendantWeight} جرام`
                                                : `${globalState.pendantWeight} gm`}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            direction: isArabic ? "rtl" : "ltr",
                                            textAlign: isArabic ? "right" : "left",
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#bdbdbd",
                                                fontSize: 12,
                                                fontWeight: isArabic ? 600 : 500,
                                            }}
                                        >
                                            {isArabic
                                                ? "الأبعاد (الطول × العرض × السُمك):"
                                                : "Dimensions"}
                                        </div>
                                        <div style={{ direction: "rtl" }}>
                                            <span dir="ltr">
                                                {(globalState.plateSize?.width / 10).toFixed(2)} x{" "}
                                                {(globalState.plateSize?.height / 10).toFixed(2)} x{" "}
                                                {(globalState.fontThickness * 0.1).toFixed(3)}{" "}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                        />
                    </div>
                    <div className="accordion_data">
                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "fontStyle"}
                            onChange={handleChangeAccordion("fontStyle")}
                            ref={accordionRefs.fontStyle}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "الخط" : "Font Style"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={0}
                                    className="tabpanel__content"
                                >
                                    <FontStyle
                                        activeFontIndex={activeFontIndex}
                                        setActiveFontIndex={setActiveFontIndex}
                                        inputText={inputText}
                                    />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "metalStyle"}
                            onChange={handleChangeAccordion("metalStyle")}
                            ref={accordionRefs.metalStyle}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "المعدن" : "Metal"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={1}
                                    className="tabpanel__content"
                                >
                                    <MetalStyle
                                        activeIndex={activeIndex}
                                        setActiveIndex={setActiveIndex}
                                    />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "thickness"}
                            onChange={handleChangeAccordion("thickness")}
                            ref={accordionRefs.thickness}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "السماكة" : "Thickness"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={2}
                                    className="tabpanel__content"
                                >
                                    <Thickness
                                        activeThickness={activeThickness}
                                        setActiveThickness={setActiveThickness}
                                    />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "stoneStyle"}
                            onChange={handleChangeAccordion("stoneStyle")}
                            ref={accordionRefs.stoneStyle}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "التعاليق والأحجار" : "Charm & Stone"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={3}
                                    className="tabpanel__content"
                                >
                                    <StoneStyle
                                        activeStone={activeStone}
                                        setActiveStone={setActiveStone}
                                    />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "chainStyle"}
                            onChange={handleChangeAccordion("chainStyle")}
                            ref={accordionRefs.chainStyle}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "السلسلة" : "Chain Style"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={4}
                                    className="tabpanel__content"
                                >
                                    <ChainStyle />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>
                        {/* <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "chainStyle"}
                            onChange={handleChangeAccordion("chainStyle")}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "السلسلة" : "Chain Style"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={4}
                                    className="tabpanel__content"
                                >
                                    <ChainStyle />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion> */}
                        <Accordion
                            className="accordion_content"
                            expanded={expandedAccordion === "addDiamond"}
                            onChange={handleChangeAccordion("addDiamond")}
                            ref={accordionRefs.addDiamond}
                        >
                            <AccordionSummary
                                className="accordion_summary"
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography
                                    sx={{
                                        direction: isArabic ? "rtl" : "ltr",
                                        textAlign: isArabic ? "right" : "left",
                                        width: "100%"
                                    }}
                                >
                                    {isArabic ? "إضافة فصوص" : "Add Diamond"}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TabPanel
                                    value={value}
                                    index={5}
                                    className="tabpanel__content"
                                >
                                    <AddDiamond />
                                </TabPanel>
                            </AccordionDetails>
                        </Accordion>
                        <div>
                            <SelectedFontInfo />
                        </div>
                    </div>
                </>
           )}
            <div className="main__sidebar_footer">
                {!isAccordionView && (
                    <div className="tabpanel__nav">
                        <Button
                            variant="text"
                            startIcon={
                                globalState.selectedFontLanguage === "Arabic" ? (
                                    <EastIcon />
                                ) : (
                                    <WestIcon />
                                )
                            }
                            onClick={handlePrev}
                            className="tabpanel__nav-item tabpanel__prev"
                        >
                            {currentButtonLabels.previous}
                        </Button>
                        <Button
                            variant="text"
                            endIcon={
                                globalState.selectedFontLanguage === "Arabic" ? (
                                    <WestIcon />
                                ) : (
                                    <EastIcon />
                                )
                            }
                            onClick={handleNext}
                            className="tabpanel__nav-item tabpanel__next"
                        >
                            {currentButtonLabels.next}
                        </Button>
                    </div>
                )}
                <div className="main__sidebar-price">
                    SAR {globalState.finalPrice}
                </div>
                {errorMessage !== "" && (
                    <Alert severity="error" className="errorMessage">
                        {errorMessage}
                    </Alert>
                )}

                <div className="main__sidebar-checkout">
                    <Button
                        variant="contained"
                        startIcon={<CheckCircleOutlineIcon />}
                        sx={{
                            padding: "16px 40px",
                        }}
                        onClick={() => handleAddToCart(1)}
                        disabled={loading2 || loading}
                    >
                        {currentButtonLabels.buyNow}
                        {loading2 && (
                            <CircularProgress className="btn_loader btn_loader_black" />
                        )}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        className="cart_btn"
                        startIcon={<ShoppingCartOutlinedIcon />}
                        onClick={() => handleAddToCart(2)}
                        disabled={loading2 || loading}
                    >
                        {currentButtonLabels.addToCart}
                        {loading && <CircularProgress className="btn_loader" />}
                    </Button>
                </div>
                <LoadMetalData />
                <DescriptionDetails />
            </div>
        </div>
    );
}

// FontAccordion component
function FontAccordion({ description, details, isArabic = false }) {
    const [expandedDetails, setExpandedDetails] = useState(false);
    const [expandedDescription, setExpandedDescription] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [expanded, setExpanded] = useState(false);
  const globalState = useContext(stateContext);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <1024);
      if (window.innerWidth >= 1024) setExpanded(true); // always expanded on desktop
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // ✅ Scroll handler (collapse on scroll, mobile only)
  const handleScroll = useCallback(() => {
    if (expanded && isMobile) {
      setExpanded(false);
      globalState.setShowMore(false);
    }
  }, [expanded, isMobile, globalState]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);


  useEffect(() => {
    const handleOutsideActivity = (event) => {
      if (sectionRef.current && !sectionRef.current.contains(event.target)) {
        setExpanded(false);
        globalState.setShowMore(false);
      }
    };

    // Listen to multiple events
    document.addEventListener("mousedown", handleOutsideActivity); // click
    document.addEventListener("touchstart", handleOutsideActivity); // mobile touch
    document.addEventListener("scroll", handleOutsideActivity, true); // scroll anywhere
    document.addEventListener("keydown", handleOutsideActivity); // keyboard activity

    return () => {
      document.removeEventListener("mousedown", handleOutsideActivity);
      document.removeEventListener("touchstart", handleOutsideActivity);
      document.removeEventListener("scroll", handleOutsideActivity, true);
      document.removeEventListener("keydown", handleOutsideActivity);
    };
  }, [globalState]);

    return (
        <div className="font-accordion-container">
            {/* Description Content - Direct display for mobile */}
            <div className="description-content-section">
                <div style={{ padding: "0" }}>
                    {description}
                </div>
            </div>

            <div className="mobile-description-content-section" ref={sectionRef}>
                <div
                      style={{
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        textOverflow: "ellipsis",
                        lineHeight: "1rem", // set line height
                        maxHeight: !expanded && isMobile ? "3em" : "none", // 2 lines x 1.5em
                        transition: "max-height 0.3s ease",
                    }}
                >
                    {description}
                </div>
                {isMobile && (
                    <div className="detail-box detail-info-box">
                        <button
                        className="show-more-button"
                        onClick={() => {
                            const newExpanded = !expanded;
                            setExpanded(newExpanded);
                            globalState.setShowMore(newExpanded);
                        }}
                        >
                            {expanded ? isArabic ? "تظهر أقل" : "Show Less" : isArabic ? "أظهر المزيد" : "Show More"}
                        </button>
                        <button onClick={() => setDialogOpen(true)}>
                            {isArabic ? "وصف المنتج" : "Product Details"}
                        </button>
                    </div>
                )}
            </div>

            {/* Description Accordion - For desktop */}
            <Accordion
                className="description-accordion"
                expanded={expandedDescription}
                onChange={() => setExpandedDescription(!expandedDescription)}
                sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    background: "#000",
                    color: "#fff",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.45)",
                    "&:before": { display: "none" },
                    marginBottom: 1,
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{
                        paddingY: 1,
                        paddingX: 2,
                        minHeight: 48,
                        "& .MuiAccordionSummary-content": { margin: 0 },
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: isArabic ? 700 : 600,
                            fontSize: 15,
                            direction: isArabic ? "rtl" : "ltr",
                            textAlign: isArabic ? "right" : "left",
                            width: "100%",
                        }}
                    >
                        {isArabic ? "الوصف" : "Description"}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: 2 }}>
                    {description}
                </AccordionDetails>
            </Accordion>

            {/* Product Details Accordion */}
            <Accordion
                className="product-details-accordion"
                expanded={expandedDetails}
                onChange={() => setExpandedDetails(!expandedDetails)}
                sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    background: "#000",
                    color: "#fff",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.45)",
                    "&:before": { display: "none" },
                    marginBottom: 1,
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                    sx={{
                        paddingY: 1,
                        paddingX: 2,
                        minHeight: 48,
                        "& .MuiAccordionSummary-content": { margin: 0 },
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: isArabic ? 700 : 600,
                            fontSize: 15,
                            direction: isArabic ? "rtl" : "ltr",
                            textAlign: isArabic ? "right" : "left",
                            width: "100%",
                        }}
                    >
                        {isArabic ? "وصف المنتج" : "Product Details"}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ padding: 2 }}>
                    {details}
                </AccordionDetails>
            </Accordion>

           

            {/* Dialog for Product Details */}
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                // maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        background: "#000",
                        color: "#fff",
                        border: "1px solid #333",
                        maxWidth: { xs: "95%", sm: "80%", md: "50%"}
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        background: "#000000",
                        color: "#ffffff",
                        borderBottom: "1px solid #333",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px 16px",
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: isArabic ? 700 : 600,
                            direction: isArabic ? "rtl" : "ltr",
                        }}
                    >
                        {isArabic ? "وصف المنتج" : "Product Details"}
                    </Typography>
                    <IconButton
                        onClick={() => setDialogOpen(false)}
                        sx={{ color: "#ffffff" }}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        background: "#000000",
                        color: "#ffffff",
                        padding: "24px !important",
                    }}
                >
                    <div>
                        {details}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
